import {FC} from "react";
import {Layout} from "antd";
import styles from './LayoutWrapper.module.css';
import {Outlet} from "react-router";
import {useOwnProfile} from "../../stores/OwnProfileStore.ts";
import {useCheckAuth} from "../../hooks/useCheckAuth.ts";
import {FeedbackFloat} from "../FeedbackFloat/FeedbackFloat.tsx";
import {Header} from "./components/Header/Header.tsx";

export const LayoutWrapper: FC = () => {
    const { profile } = useOwnProfile();

    useCheckAuth({
        redirectOnError: '/auth'
    });

    return (
        <Layout className={styles.layout}>
            <Header />
            <Layout.Content className={styles.content}>
                <Outlet />
                {profile && <FeedbackFloat />}
            </Layout.Content>
        </Layout>
    )
}